import { makeStyles } from '@material-ui/core/styles';

export const useLocalStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(1)
  },
  scopeNote: {
    marginBottom: theme.spacing(4)
  }
}));
